module.exports = __webpack_public_path__ + "86399ebd581d5493edbb5aa6aa5bfa1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food1.png
// module id = 1951
// module chunks = 0